import { Component, OnInit } from '@angular/core';
import { ListDocumentProfileSurveyService } from '../../service/list-document-profile-survey/list-document-profile-survey.service';
import { ListDocumentProfileSurvey } from '../../class/list-document-profile-survey';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { config } from '../../../../../environments/config';
import { CompanyService } from '../../service/company/company.service';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { calendarES } from '../../../../theme/functions/calendarES';


@Component({
  selector: 'app-list-document-profile-surveis',
  templateUrl: './list-document-profile-surveis.component.html',
  styleUrls: ['./list-document-profile-surveis.component.scss']
})
export class ListDocumentProfileSurveisComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public listDocumentProfileSurveys: ListDocumentProfileSurvey[];
    public selectListDocumentProfileSurvey: ListDocumentProfileSurvey;
    public listDocumentProfileSurveyID: Number = 0;
    public modNew = false;
    public modView = false;
    public openListDocumentProfileSurvey = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public form3: FormGroup;
    public company_id_filter: AbstractControl;
    public params_id_company: number;

    public modExportDialog: boolean;
    public form4: FormGroup;
    public f4_company_id: AbstractControl;
    public apiUrl = config.API_ROOT;

    public filters: any[];

    public es: any;

    public first = 0;

    constructor(
        public listDocumentProfileSurveyService: ListDocumentProfileSurveyService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        public activatedRoute: ActivatedRoute,
        public companyService: CompanyService,
        private notificationsService: NotificationsService,
        fb: FormBuilder) {
            this.form3 = fb.group({
                'company_id_filter': [''],
            });
            this.company_id_filter = this.form3.controls['company_id_filter'];

            this.es = calendarES();            
    
            this.form4 = fb.group({
                'f4_company_id': [''],
            });
            this.f4_company_id = this.form4.controls['f4_company_id'];

            this.modExportDialog = false;
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 1000;
        this.sort = '-id';

        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_company']) {
                this.params_id_company = Number(params['id_company']);
                const filters = [];
                if (this.params_id_company) {
                    filters.push({key: 'id-lk', value: String(this.params_id_company)});
                }
                this.getCompanies(undefined, filters);
            }
            // this.filter();
        });
    }

    public loadListDocumentProfileSurveysLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';
        this.filter();
    }

    public getListDocumentProfileSurveis() {
        this.listDocumentProfileSurveyService.getListDocumentProfileSurvey(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.listDocumentProfileSurveys = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getListDocumentProfileSurveyId(id) {
        this.listDocumentProfileSurveyService.infoListDocumentProfileSurvey(id).toPromise().then(
            response => {
                this.selectListDocumentProfileSurvey = response.json().data[0];
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                        // this.msg.emit( { severity: 'error', summary: 'Error' } );
                    });
                });
            }
        );
    }

    public newListDocumentProfileSurvey() {
        this.modNew = !this.modNew;
        this.selectListDocumentProfileSurvey = null;
    }

    public savedListDocumentProfileSurvey(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectListDocumentProfileSurvey = null;
        this.modNew = false;
        // this.getListDocumentProfileSurveis();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public cancelListDocumentProfileSurvey (res) {
        this.selectListDocumentProfileSurvey = null;
        this.modNew = false;
        this.modView = false;
        // this.getListDocumentProfileSurveis();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public edit(ListDocumentProfileSurvey: ListDocumentProfileSurvey) {
        this.modNew = true;
        this.selectListDocumentProfileSurvey = ListDocumentProfileSurvey;
        // this.getListDocumentProfileSurveis();
    }

    public reloadListDocumentProfileSurvey(id) {
        this.getListDocumentProfileSurveyId(id);
    }

    public view(ListDocumentProfileSurvey: ListDocumentProfileSurvey) {
        this.openListDocumentProfileSurvey = true;
        this.selectListDocumentProfileSurvey = ListDocumentProfileSurvey;
        this.listDocumentProfileSurveyID = ListDocumentProfileSurvey.id;
        this.modView = true;
    }

    public deleteDialog(ListDocumentProfileSurvey: ListDocumentProfileSurvey) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(ListDocumentProfileSurvey);
            }
        });
    }

    public delete(ListDocumentProfileSurvey: ListDocumentProfileSurvey) {
        this.listDocumentProfileSurveyService.deleteListDocumentProfileSurvey(ListDocumentProfileSurvey.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getListDocumentProfileSurveis();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeListDocumentProfileSurvey(ListDocumentProfileSurvey: ListDocumentProfileSurvey) {
        this.putListDocumentProfileSurvey(ListDocumentProfileSurvey);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public putListDocumentProfileSurvey(values: ListDocumentProfileSurvey) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.listDocumentProfileSurveyService.updateListDocumentProfileSurvey(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public filterRefresh () {
        this.params_id_company = undefined;
        this.filter(true);
    }

    public filter (pageRefresh?) {
        if (pageRefresh) {
            this.page = 1;
            this.first = 0;
        }

        this.filters = [];
        if (this.company_id_filter.value) {
            if (this.company_id_filter.value.id) {
                this.filters.push({'key': 'company_id-lk', 'value': this.company_id_filter.value.id});
            }
        } else if (this.params_id_company) {
            this.filters.push({'key': 'company_id-lk', 'value': this.params_id_company});
        }
        this.getListDocumentProfileSurveis();
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportExcel(values) {
        let url = this.apiUrl + '/ListDocumentProfileSurveys/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=id&';

        if (values.f4_company_id) {
            url = url + 'company_id-in=' + values.f4_company_id.id + '&';
        }

        window.open(url, '_blank');
    }    

    // public formatDate(date) {
    //     const d = new Date(date);
    //     let month = '' + (d.getMonth() + 1);
    //     let day = '' + d.getDate();
    //     const year = d.getFullYear();
    //     let hours = '' + d.getHours();
    //     let minutes = '' + d.getMinutes();
    //     let seconds = '' + d.getSeconds();

    //     if (month.length < 2) {
    //         month = '0' + month;
    //     }
    //     if (day.length < 2) {
    //         day = '0' + day;
    //     }

    //     if (hours.length < 2) {
    //         hours = '0' + hours;
    //     }

    //     if (minutes.length < 2) {
    //         minutes = '0' + minutes;
    //     }

    //     if (seconds.length < 2) {
    //         seconds = '0' + seconds;
    //     }

    //     return [year, month, day].join('-') + ' ' + [hours, minutes, seconds].join(':');
    // }

    getCompanies(query?: string, filters?: any[]) {
        this.companyService.getCompany(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                const companiesOptions = response.json().data;
                this.company_id_filter.setValue(companiesOptions[0]);
            },
            error => {
                this.company_id_filter.setValue(undefined);
            }
        );
    }

    public gotoAttachment(id) {
        window.open(this.apiUrl + '/list-document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/list-document-profile-surveis/list-document-profile-surveis.component.ts